import { render, staticRenderFns } from "./MunicipalitiesList.vue?vue&type=template&id=399aafb4&scoped=true&"
import script from "./MunicipalitiesList.vue?vue&type=script&lang=js&"
export * from "./MunicipalitiesList.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalitiesList.vue?vue&type=style&index=0&id=399aafb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399aafb4",
  null
  
)

export default component.exports